import Request from './request'

const ClientRequest  = {
  getClientRequestList(params, callback) {
    Request.get('client-request/index', params).then(callback).catch(this.bad_answer)
  },
  getClientRequest(id, callback) {
    Request.get('client-request/view/' + id).then(callback).catch(this.bad_answer)
  },
  getClientRequestDevice(fid, callback) {
    Request.get('client-request/device-view/' + fid).then(callback).catch(this.bad_answer)
  },
  updateStatusClientRequest(id, params, callback) {
    Request.post('client-request/update-status/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateClientRequest(id, params,callback){
    Request.post('client-request/update/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  addSimcardClientRequest(id, params, callback) {
    Request.post('client-request/add-simcard/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  removeSimcardClientRequest(id, params, callback) {
    Request.post('client-request/remove-simcard/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateSimcardStatusClientRequest(id, params, callback) {
    Request.post('client-request/update-simcard-status/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default ClientRequest
